import { useEffect, useState } from "react";

import {
  EmptyQuestProgress,
  EmptyQuestTaskProgress,
} from "~/components/category/[id]/quest/lib";
import { useGraphqlClient } from "~/lib/client/hooks/useGraphqlClient";
import { UserQuestProgressQuery } from "~/lib/graphql/client";
import { useAppContext } from "~/pages/_app";

type QuestTask = {
  id: number;
};

type Quest = {
  id: number;
  questTasks: QuestTask[];
};

function useUserQuestProgress(quests: Quest[]) {
  const client = useGraphqlClient();
  const { currentUser } = useAppContext();

  const [questProgress, setQuestProgress] = useState<UserQuestProgressQuery>({
    currentUserQuestProgresses: quests.map((quest) =>
      EmptyQuestProgress(quest.id)
    ),
    currentUserQuestTaskProgresses: quests.flatMap((quest) =>
      quest.questTasks.map((task) => EmptyQuestTaskProgress(task.id))
    ),
  });

  useEffect(() => {
    (async () => {
      if (!client) return;
      if (!currentUser) return;

      const { currentUserQuestProgresses, currentUserQuestTaskProgresses } =
        await client.userQuestProgress({
          questIds: quests.map((quest) => quest.id),
          questTaskIds: quests.flatMap((quest) =>
            quest.questTasks.map((task) => task.id)
          ),
        });

      setQuestProgress({
        currentUserQuestProgresses,
        currentUserQuestTaskProgresses,
      });
    })();
  }, [client, currentUser, quests]);

  return questProgress;
}

export default useUserQuestProgress;
